import {BACKEND_API} from '../middleware/backend'

export const INTAKES_REQUEST = 'INTAKES_REQUEST';
export const INTAKES_SUCCESS = 'INTAKES_SUCCESS';
export const INTAKES_FAILURE = 'INTAKES_FAILURE';
export const INTAKES_COUNT_REQUEST = 'INTAKES_COUNT_REQUEST';
export const INTAKES_COUNT_SUCCESS = 'INTAKES_COUNT_SUCCESS';
export const INTAKES_COUNT_FAILURE = 'INTAKES_COUNT_FAILURE';
export const INTAKE_REQUEST = 'INTAKE_REQUEST';
export const INTAKE_SUCCESS = 'INTAKE_SUCCESS';
export const INTAKE_FAILURE = 'INTAKE_FAILURE';
export const INTAKE_SAVE_REQUEST = 'INTAKE_SAVE_REQUEST';
export const INTAKE_SAVE_SUCCESS = 'INTAKE_SAVE_SUCCESS';
export const INTAKE_SAVE_FAILURE = 'INTAKE_SAVE_FAILURE';
export const INTAKE_INFO_REQUEST = 'INTAKE_INFO_REQUEST';
export const INTAKE_INFO_SUCCESS = 'INTAKE_INFO_SUCCESS';
export const INTAKE_INFO_FAILURE = 'INTAKE_INFO_FAILURE';

export const loadIntakes = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [INTAKES_REQUEST, INTAKES_SUCCESS, INTAKES_FAILURE],
			endpoint: "intake/list",
			filter: filter
		}
	})
};

export const countIntakes = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [INTAKES_COUNT_REQUEST, INTAKES_COUNT_SUCCESS, INTAKES_COUNT_FAILURE],
			endpoint: "intake/count",
			filter: filter
		}
	})
};

export const loadIntake = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [INTAKE_REQUEST, INTAKE_SUCCESS, INTAKE_FAILURE],
			endpoint: `intake/${id}`,
		}
	})
};

export const saveIntake = (intake) => (dispatch, getState) => {
	return dispatch({
		id: intake.intakeId,
		intake: intake,
		[BACKEND_API]: {
			types: [INTAKE_SAVE_REQUEST, INTAKE_SAVE_SUCCESS, INTAKE_SAVE_FAILURE],
			endpoint: 'intake',
			body: intake,
			silent: true
		}
	})
};

export const loadIntakeInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [INTAKE_INFO_REQUEST, INTAKE_INFO_SUCCESS, INTAKE_INFO_FAILURE],
			endpoint: `intake/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/intakes.js